<div class="d-flex flex-row justify-content-between align-items-center">
  <h5>{{ 'CASES.single.general.relation_list.product_logs.heading' | translate }}</h5>
</div>
<div class="pt-4" *ngIf="isLoading">
  <mat-spinner class="m-0 m-auto"></mat-spinner>
</div>
<app-empty-dataset [show]="!isLoading && !caseProductLogs?.length"
                   [message]="'CASES.single.general.relation_list.product_logs.empty_dataset' | translate">
</app-empty-dataset>
<div class="row m-2" *ngFor="let product of caseProductLogs" [hidden]="isLoading">
  <div class="card col-12">
    <div class="card-body">
      <span *ngIf="product.from_product_id">
        {{ 'CASES.single.general.relation_list.product_logs.product_changed_from' | translate }} {{ product.from_product.name }}
      </span>
      <span *ngIf="!product.from_product_id">{{ 'CASES.single.general.relation_list.product_logs.no_old_status' | translate }}</span>
      <span *ngIf="product.to_product_id">
        {{ ' ' }} {{ 'CASES.single.general.relation_list.product_logs.product_changed_to' | translate }} {{ product.to_product.name }}
      </span>
      <span *ngIf="product.author_id">
        {{ ' ' }} {{ 'CASES.single.general.relation_list.product_logs.product_changed_by' | translate }} {{ product?.author?.name }}
      </span>
      <p>{{ product.created_at| toDateObject | date: 'medium'}}</p>
    </div>
  </div>
</div>
